// extracted by mini-css-extract-plugin
export var centerText = "_6o-8";
export var container = "_6o-0";
export var doughnutContainer = "_6o-7";
export var legend = "_6o-a";
export var legendItemColorDisplay = "_6o-b";
export var legendItemLabel = "_6o-d";
export var legendItemValue = "_6o-c";
export var lg = "_6o-5";
export var maxWidth = "_6o-9";
export var md = "_6o-4";
export var responsive = "_6o-6";
export var sm = "_6o-3";
export var xs = "_6o-2";
export var xxs = "_6o-1";